import h from 'react-hyperscript';

import Overlay, { overlayTypes } from './Overlay';

export default () => h(Overlay, { type: overlayTypes.TRIAL_ENDED });



// WEBPACK FOOTER //
// ./src/components/Overlay/OverlayTrialHasEnded.js